import { connect } from 'react-redux'
import RiderList from '../../components/trips/riders/RiderList'
import * as actions from '../../state/actions/trips'
import { IStoreState } from '../../types'
import { IRiderSearchObject } from '../../types/rider'

export function mapStateToProps(state: IStoreState) {
  return {
    riders: state.riderSearch.items,
    isFetching: state.riderSearch.isFetching,
    pageCount: state.riderSearch.metadata.pageCount,
    pageSize: state.riderSearch.metadata.pageSize
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    onChooseRider: (rider: IRiderSearchObject) => dispatch(actions.selectRider(rider))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RiderList)



// WEBPACK FOOTER //
// ./src/containers/trips/RidersList.ts